const common = require("lib/labels/_common");

// Project

module.exports = {
  workspaceMenu: {
    tasks: {
      title: {
        en: "Tasks",
        fr: "Tâches"
      },
      name: {
        en: "Name",
        fr: "Nom"
      },
      status: {
        en: "Status",
        fr: "Etat"
      },
      type: {
        en: "Type",
        fr: "Type"
      },
      queue: {
        en: "Queue",
        fr: "Queue"
      },
      logs: {
        en: "Logs",
        fr: "Messages"
      },
      progress: {
        en: "Progress",
        fr: "Progression"
      },
      pending: {
        en: "pending",
        fr: "en attente"
      },
      active: {
        en: "active",
        fr: "En cours"
      },
      failed: {
        en: "failed",
        fr: "échec"
      },
      completed: {
        en: "completed",
        fr: "terminé"
      },
      stalled: {
        en: "stalled",
        fr: "bloqué"
      },
      closePopup: {
        en: "Close",
        fr: "Fermer"
      },
      logsTitle: {
        en: "Logs",
        fr: "Logs"
      },
      showLogs: {
        en: "Logs",
        fr: "Logs"
      }
    },
    storage: {
      title: {
        en: "Storage",
        fr: "Stockage"
      },
      folders: {
        title: {
          en: "Folders",
          fr: "Répertoires"
        }
      },
      toolbar: {
        import: {
          en: "Import",
          fr: "Importer"
        },
        export: {
          en: "Export",
          fr: "Exporter"
        }
      },
      size: {
        en: "size",
        fr: "taille"
      },
      delete: common.remove,
      download: {
        en: "Download",
        fr: "Télécharger"
      },
      upload: {
        en: "Upload file",
        fr: "Upload du fichier"
      },
      alert: {
        title: {
          en: "Warning",
          fr: "Attention"
        },
        text: {
          en: "Are you sure to delete this file?",
          fr: "Etes-vous sûr de vouloir supprimer ce fichier ?"
        },
        cancel: common.cancel,
        confirm: common.confirm
      }
    }
  },
  workflowNav: {
    tools: {
      en: "Tools",
      fr: "Outils"
    }
  },
  appsnavbar: {
    applications: common.apps,
    modules: {
      en: "Modules",
      fr: "Modules"
    }
  },
  loadbundle: {
    errorbundle: {
      error: {
        en: "ERROR",
        fr: "ERREUR"
      },
      unavailable: {
        en: "App unavailable",
        fr: "Application indisponible"
      },
      retry: {
        en: "Retry",
        fr: "Réessayer"
      },
      contactAdmin: {
        en: "or contact administrator",
        fr: "ou contacter l'administrateur"
      }
    }
  },
  projectLoading: {
    en: "Project loading",
    fr: "Chargement du projet"
  },
  projectReconnect: {
    en: "Project reconnection",
    fr: "Reconnexion du projet"
  },
  reload: {
    en: "Reload",
    fr: "Recharger"
  }
};
